import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import { ChevronDown } from "lucide-react";

const Select = forwardRef(({ children, className = "", placeholder, ...props }, ref) => (
  <div className="wsm-select-wrap">
    <select {...props} className={["wsm-select", className].filter(Boolean).join(" ")} ref={ref}>
      {placeholder && <option value="">{placeholder}</option>}
      {children}
    </select>
    <ChevronDown aria-hidden="true" className="wsm-select-wrap__icon" />
  </div>
));

Select.displayName = "Select";
Select.propTypes = { children: PropTypes.node.isRequired, className: PropTypes.string, placeholder: PropTypes.string };
export default Select;
